export default {
    state: {
        headers: [
            { text: 'Title', align: 'center', sortable: false, value: 'title' },
            { text: 'Interaction ID', align: 'center', sortable: false, value: 'interaction_id' },
            // { text: 'Course', align: 'center', sortable: false, value: 'course_name' },
        ],
        notes: {
        },
        records: [],
        editCourse:null,
        status:['Purchased Unit', 'Leased Unit', 'Unit Removed','Transfer Unit','Not Recovered','Credit Only','Amber','Purchased Not Removed','Transferred and Billed','Removed Unit','Purchased Unit Removed',]
    },
    getters: {


    },
    mutations: {
        setInteractions (state, data){
            state.notes.records = data;
            state.status.sort();
        }
    },
    actions: {
        setInteractions ({commit}, data){
            commit('setInteractions', data)
        }
    }
}